<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品图">
        <template slot-scope="scope">
          <el-image :src="scope.row.goodsImg"
          alt="" style="width: 80px;height: 80px;"
          :preview-src-list="[scope.row.goodsImg]" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="说明视频">
        <template slot-scope="scope">
          <video :src="scope.row.exampleVideo"
          style="width: 80px;height: 80px;cursor: pointer;"
          :controls="false"
          @click="openVideo(scope.row.exampleVideo)"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频封面">
        <template slot-scope="scope">
          <el-image :src="scope.row.exampleImg"
          alt="" style="width: 80px;height: 80px;"
          :preview-src-list="[scope.row.exampleImg]" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="220">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit"
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            icon="el-icon-delete"
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog :visible.sync="dialogFormVisible"  :title="textMap[dialogStatus]" width="80%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" size="small" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="检测图" prop="markers">
          <div class="marker-tip">
            同一商品可上传多个角度的检测图。优先级数字越小越优先；首个启用检测图会自动同步为兼容旧版本的商品图。
          </div>
          <div v-for="(marker, index) in form.markers" :key="marker.id || marker.localKey" class="marker-item">
            <div class="marker-item__header">
              <span>检测图 {{ index + 1 }}</span>
              <el-button type="text" class="marker-item__remove" @click="removeMarker(index)">移除</el-button>
            </div>
            <el-row :gutter="16">
              <el-col :span="8">
                <div class="marker-item__label">检测图片</div>
                <UploadImage v-model="marker.markerImg" :max="1" :show-tips="false"></UploadImage>
              </el-col>
              <el-col :span="7">
                <div class="marker-item__label">名称</div>
                <el-input v-model="marker.markerName" size="small" placeholder="例如：礼盒正面"></el-input>
              </el-col>
              <el-col :span="5">
                <div class="marker-item__label">识别优先级</div>
                <el-input-number v-model="marker.priority" :min="0" :step="1" controls-position="right" size="small" style="width: 100%;"></el-input-number>
              </el-col>
              <el-col :span="4">
                <div class="marker-item__label">状态</div>
                <el-switch v-model="marker.enabled" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"></el-switch>
              </el-col>
            </el-row>
          </div>
          <el-button size="mini" type="primary" icon="el-icon-circle-plus" @click="addMarker">添加检测图</el-button>
        </el-form-item>
        <el-form-item label="说明视频" prop="exampleVideo">
          <UploadVideo v-model="form.exampleVideo" :max="1"></UploadVideo>
        </el-form-item>
        <el-form-item label="视频封面" prop="exampleImg">
          <UploadImage v-model="form.exampleImg" :max="1" ></UploadImage>
        </el-form-item>

        <!-- 类型 -->
        <el-form-item label="场景类型" prop="type">
          <!-- 单选按钮 -->
          <el-radio-group v-model="form.type">
            <el-radio :label="0">视频</el-radio>
            <el-radio :label="1">文字</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.type === 0" label="启动视频" prop="startVideo">
          <UploadVideo v-model="form.startVideo" :max="1"></UploadVideo>
        </el-form-item>
        <el-form-item v-if="form.type === 1" label="模型文件" prop="text">
          <UploadFile v-model="form.startVideo" :max="1" :text="['仅支持GLB文件']"></UploadFile>
        </el-form-item>
        <el-form-item label="智能体" prop="botId">
         <!-- 智能体选项 -->
          <el-select v-model="form.botId" placeholder="请选择智能体">
            <el-option v-for="item in agentList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数列表" prop="paramList">
          <love-msg-param-item
            v-for="(item, index) in form.paramList"
            :key="index"
            :value="item"
            @change="handleParamChange(index, $event)"
            @delete="handleParamDelete(index)"
          ></love-msg-param-item>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            @click="addParam"
          >添加参数</el-button>
        </el-form-item>
      </el-form>
      <!-- 测试 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  getGoodsList,
  addGoods,
  editGoods,
  deleteGoods,
  getGoodsDetail
} from '@/api/demo/arLoveMsg'
import { agentOptions } from '@/api/merchant/agent'
import loveMsgParamItem from '@/components/loveMsg/LoveMsgParamItem.vue'
// 上传图片
import UploadImage from '@/components/uploadImage/index.vue'
// 上传视频
import UploadVideo from '@/components/uploadVideo/index.vue'
// 上传文件
import UploadFile from '@/components/uploadFile/index.vue'

function createDefaultMarker (index) {
  return {
    localKey: `new-marker-${Date.now()}-${index}`,
    markerImg: '',
    markerName: '',
    priority: (index + 1) * 10,
    enabled: 1
  }
}

function createDefaultForm () {
  return {
    id: '',
    name: '',
    type: 0,
    // 保存时会由首个启用检测图自动同步，继续兼容旧接口/旧商品列表。
    goodsImg: '',
    markers: [createDefaultMarker(0)],
    exampleVideo: '',
    exampleImg: '',
    paramList: [],
    botId: '',
    startVideo: ''
  }
}

export default {
  name: 'agentBot',
  components: {
    loveMsgParamItem,
    UploadImage,
    UploadVideo,
    UploadFile
  },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      testLoading: false,
      dialogFormVisible: false,
      keywordList: [],
      testResult: [],
      agentList: [],
      form: createDefaultForm(),
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '名称',
            trigger: 'blur'
          }
        ],
        botId: [
          {
            required: false,
            message: '智能体',
            trigger: 'blur'
          }
        ],
        startVideo: [
          {
            required: true,
            message: '启动视频',
            trigger: 'blur'
          }
        ],
        markers: [
          {
            required: true,
            message: '请至少配置一张检测图',
            trigger: 'change'
          }
        ],
        exampleVideo: [
          {
            required: true,
            message: '说明视频',
            trigger: 'blur'
          }
        ],
        exampleImg: [
          {
            required: true,
            message: '视频封面',
            trigger: 'blur'
          }
        ],
        paramList: [
          {
            required: true,
            message: '参数列表',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
    this.getAgentList()
  },
  watch: {
  },
  methods: {
    getAgentList () {
      agentOptions().then(res => {
        this.agentList = res
      })
    },
    openVideo (url) {
      window.open(url, '_blank')
    },
    addParam () {
      this.form.paramList.push({
        name: '',
        type: '',
        desc: ''
      })
    },
    handleParamChange (index, value) {
      this.form.paramList[index] = value
    },
    handleParamDelete (index) {
      this.form.paramList.splice(index, 1)
    },
    addMarker () {
      this.form.markers.push(createDefaultMarker(this.form.markers.length))
    },
    removeMarker (index) {
      this.form.markers.splice(index, 1)
    },
    normalizeLoadedMarkers (detail) {
      const sourceMarkers = Array.isArray(detail.markers) && detail.markers.length
        ? detail.markers
        : detail.goodsImg
          ? [{ markerImg: detail.goodsImg, markerName: '默认检测图', priority: 100, enabled: 1 }]
          : []
      return sourceMarkers.map((marker, index) => ({
        ...createDefaultMarker(index),
        ...marker,
        localKey: marker.id || `loaded-marker-${index}`,
        markerImg: marker.markerImg || marker.imageUrl || marker.goodsImg || '',
        markerName: marker.markerName || marker.name || '',
        priority: Number(marker.priority === undefined || marker.priority === null ? (index + 1) * 10 : marker.priority),
        enabled: Number(marker.enabled === undefined || marker.enabled === null ? 1 : marker.enabled)
      }))
    },
    getSubmitPayload () {
      const markers = Array.isArray(this.form.markers) ? this.form.markers : []
      if (!markers.length) {
        this.$message.warning('请至少添加一张检测图')
        return null
      }
      if (markers.some(marker => !marker.markerImg || !String(marker.markerImg).trim())) {
        this.$message.warning('每一项检测图都需要上传图片；不需要的项目请移除')
        return null
      }
      const normalizedMarkers = markers.map((marker, index) => ({
        id: marker.id || undefined,
        markerImg: String(marker.markerImg).trim(),
        markerName: String(marker.markerName || '').trim(),
        priority: Number(marker.priority === undefined || marker.priority === null ? (index + 1) * 10 : marker.priority),
        enabled: Number(marker.enabled === 0 ? 0 : 1)
      }))
      const enabledMarkers = normalizedMarkers.filter(marker => marker.enabled === 1)
      if (!enabledMarkers.length) {
        this.$message.warning('请至少启用一张检测图')
        return null
      }
      const primaryMarker = enabledMarkers.slice().sort((left, right) => left.priority - right.priority)[0]
      return {
        ...this.form,
        // 旧字段仍同步，供旧小程序和后台列表缩略图使用。
        goodsImg: primaryMarker.markerImg,
        markers: normalizedMarkers
      }
    },
    submitForm () {
      const payload = this.getSubmitPayload()
      if (!payload) return
      let that = this
      if (that.dialogStatus === 'create') {
        addGoods(payload).then(res => {
          that.$message({
            message: '添加成功',
            type: 'success',
            center: true
          })
          that.dialogFormVisible = false
          that.getSearch()
        })
      } else {
        editGoods(that.form.id, payload).then(res => {
          that.$message({
            message: '修改成功',
            type: 'success',
            center: true
          })
          that.dialogFormVisible = false
          that.getSearch()
        })
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getGoodsList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        () => {
          this.$message.error('商品列表加载失败，请稍后重试')
        }
      )
    },
    add () {
      this.form = createDefaultForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    // 编辑
    editCard (id) {
      getGoodsDetail(id).then(res => {
        const detail = res || {}
        this.form = {
          ...createDefaultForm(),
          ...detail,
          id,
          paramList: Array.isArray(detail.paramList) ? detail.paramList : [],
          markers: this.normalizeLoadedMarkers(detail)
        }
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteGoods(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.marker-tip {
  margin-bottom: 12px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
.marker-item {
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 600;
  }
  &__remove {
    padding: 0;
  }
  &__label {
    margin-bottom: 8px;
    color: #606266;
    font-size: 12px;
  }
}
.prompt-tip {
  font-size: 12px;
  color: #999;
  margin: 10px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 10px;
}

.test-prompt {
  margin-top: 20px;
  .test-prompt-content {
    display: flex;
    align-items: center;
    .test-prompt-content-item-result {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .test-prompt-content-item-result-item {
        width: 300px;
        margin: 10px;
        border: 1px solid #ccc;
        padding: 10px;
        border-radius: 10px;
        .test-prompt-content-item-result-item-name {
          font-size: 14px;
          font-weight: 600;
        }
        .test-prompt-content-item-result-item-type {
          font-size: 12px;
          color: #999;
        }
        .test-prompt-content-item-result-item-result {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
